import { formatDate as canonicalFormatDate } from "@/libs/i18n/format-date";

export function isValidDate(date: Date) {
  return (
    date instanceof Date &&
    !Number.isNaN(date.getTime()) &&
    date.getFullYear() >= 1000 &&
    date.getFullYear() <= 9999
  );
}
export function stripTimeFromDate(date: Date) {
  const strippedDate = new Date(date);
  strippedDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
  return strippedDate;
}

export function formatDate(date: Date) {
  return canonicalFormatDate(date, "yyyy-MM-dd");
}

export function dateDifferenceInDays(startDate: Date, endDate: Date): number {
  if (!startDate || !endDate) {
    return NaN;
  }
  // Strip time components to compare only calendar dates
  const strippedStartDate = stripTimeFromDate(startDate);
  const strippedEndDate = stripTimeFromDate(endDate);

  const diffInTime = strippedEndDate.getTime() - strippedStartDate.getTime();
  const diffInDays = diffInTime / (1000 * 3600 * 24);
  if (diffInDays < 0) {
    return NaN;
  }
  return Math.round(diffInDays);
}

export function isSameDay(date1: Date, date2: Date) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function returnCalculateDate(
  date: Date,
  year: number | null,
  month: number | null,
  day: number | null
) {
  const newDate = new Date(date);

  if (year !== null) {
    newDate.setFullYear(newDate.getFullYear() + year);
  }

  if (month !== null) {
    newDate.setMonth(newDate.getMonth() + month);
  }

  if (day !== null) {
    newDate.setDate(newDate.getDate() + day);
  }

  return newDate;
}

export function checkCurentLocation(fromLocation: string, toLocation: string) {
  let sameLocation = false;
  if (toLocation) {
    if (fromLocation === toLocation) {
      sameLocation = true;
    } else if (
      (toLocation === "GB" ||
        toLocation === "JE" ||
        toLocation === "IM" ||
        toLocation === "GG") &&
      fromLocation === "GB"
    ) {
      sameLocation = true;
    } else if (
      fromLocation === "ES" &&
      (toLocation === "ES-CN" || toLocation === "ES-IB" || toLocation === "ESP")
    ) {
      sameLocation = true;
    }
  }
  return sameLocation;
}
